module.exports = __webpack_public_path__ + "img/icona-04yuangongguanlibeifen.72c52bb6.png";